import React from 'react';
import Text from '../../../elements/Text';
import { T } from '../../../helpers/i18n';
import { BlockSeparator } from './BlockSeparator';
export const BlockAfiliate = ({ item }) => {
    return (React.createElement(React.Fragment, null,
        item.afiliateName && (React.createElement(React.Fragment, null,
            React.createElement(Text, { style: { marginTop: 0, marginBottom: 0 } }, `${T('afiliate')}: ${item.afiliateName}`))),
        item.afiliateName && React.createElement(BlockSeparator, null)));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/Ticket/Blocks/BlockAfiliate.tsx
// module id = 529
// module chunks = 0